export function UseUrlHandler(url) {
    if (!url) {
        return '#'
    } else {
        // if (url[0] === '/') {
        //     return `https://facilityfinderimages.s3.amazonaws.com${url}`
        // } else {
        //     return `https://facilityfinderimages.s3.amazonaws.com/${url}`
        // }

        if (url[0] === '/') {
            return `https://d10ar8zbpjh76t.cloudfront.net${url}`
        } else {
            return `https://d10ar8zbpjh76t.cloudfront.net/${url}`
        }
    }
}

